import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../services/commons-dialog.service";
import {SplitService} from "../../services/split-service.service";
import {DateRangeTimeFiltersService} from "../../services/date-range-time-filters.service";

export class DateRangePickerComponent implements IController {
  selectedRange: any;
  min: any;
  max: any;
  customTemplates: any;
  isDisabled: any;
  configTimeZone: any;
  onChange: Function;

  // configTimeZone:any;
  configTimeZoneOffset: any;
  defaultSelection: any = {};
  buttonDisplayName: any;
  localizationValues: any;
  dateFormat: any;

  constructor(private $log, private $mdDateRangePicker, private moment, private dateRangeTimeFiltersService: DateRangeTimeFiltersService,
              private $filter, private splitService: SplitService, private commonsDialogService: CommonsDialogService, private $mdMedia) {
    this.localizationValues = this.dateRangeTimeFiltersService.getLocalizationValues();
    this.dateFormat = this.splitService.getDateAndTimeConfig();
  }

  $onInit() {

    if (!this.configTimeZone) {
      this.configTimeZone = this.splitService.getTimeZone();
    }

    this.configTimeZoneOffset = this.splitService.getTimeZoneOffsetByDate(this.configTimeZone, Date.now());

    if (_.isUndefined(this.selectedRange)) {
      this.selectedRange = this.dateRangeTimeFiltersService.today();
    }

    if (_.isUndefined(this.customTemplates)) {
      this.customTemplates = [];
    }

    _.forEach(this.customTemplates, customTemplate => {
      customTemplate.dateStart = this.getDate(customTemplate.dateStart);
      customTemplate.dateEnd = this.getDate(customTemplate.dateEnd);
    });

    this.selectedRange = {
      name: this.getName(this.selectedRange.dateStart, this.selectedRange.dateEnd, this.selectedRange.name),
      dateStart: this.getDate(this.selectedRange.dateStart),
      dateEnd: this.getDate(this.selectedRange.dateEnd)
    };

    let selectedTemplate = this.getSelectedTemplate(
      this.customTemplates,
      this.selectedRange.dateStart,
      this.selectedRange.dateEnd,
      this.selectedRange.type
    );

    this.defaultSelection = {
      selectedTemplate: selectedTemplate ? selectedTemplate.name : this.selectedRange.name,
      selectedTemplateName: selectedTemplate ? selectedTemplate.name : this.selectedRange.name,
      dateStart: this.selectedRange.dateStart,
      dateEnd: this.selectedRange.dateEnd,
      min: this.min,
      max: this.max,
      showTemplate: true,
      customTemplates: this.customTemplates,
      fullscreen: true,
      firstDayOfWeek: 0,
      disableTemplates: "TD,YD,TW,LW,TY,LY,TM,LM",
      localizationMap: {}
    };

    this.buttonDisplayName = selectedTemplate ? selectedTemplate.name : (this.selectedRange.name || this.getName(
      this.selectedRange.dateStart,
      this.selectedRange.dateEnd,
      _.get(selectedTemplate, 'name')
    ));

  };

  $onChanges(changes) {
    if ((changes.selectedRange && !changes.selectedRange.isFirstChange())) {
      const currentDateStart = _.get(this.defaultSelection, 'dateStart');
      const currentDateEnd = _.get(this.defaultSelection, 'dateEnd');
      const updatedDateStart = _.get(this.selectedRange, 'dateStart');
      const updatedDateEnd = _.get(this.selectedRange, 'dateEnd');

      if (!_.isEqual(currentDateStart, updatedDateStart) || !_.isEqual(currentDateEnd, updatedDateEnd)) {
        if (this.selectedRange) {
          this.selectedRange.name = undefined;
        }
        this.$onInit()
      }
    }
  };

  openCalendar($event) {

    // Translate All Customer Buttons Selection
    _.forEach(this.defaultSelection.customTemplates, c => {
      c.name = this.$filter('translate')(c.name);
    });

    // Translate all Localization Values (Months and days)
    _.forOwn(this.localizationValues, (value, key) => {
      _.set(this.defaultSelection.localizationMap, key, this.$filter('translate')(value))
    });

    this.commonsDialogService.dateSelection($event, this.defaultSelection)
      // $mdDateRangePicker.show({
      //     targetEvent: $event,
      //     models: ctrl.defaultSelection
      // })
      .then((selectedDateRange) => {
        this.setSelectedRange(selectedDateRange);
      })
      .catch((err) => {
        this.$log.error('Failed to filter by date', err);
      })
      .finally(() => {
        this.$log.info('Dialog Closed')
      })
  }

  private setSelectedRange(selectedDateRange) {

    if (selectedDateRange) {
      let selectedDateRangeCopy = angular.copy(selectedDateRange);

      if (!_.isEqual(selectedDateRange.dateStart, null) && !_.isEqual(selectedDateRange.dateEnd, null)) {
        this.defaultSelection = selectedDateRange;
      }

      // The selected date in timestamp
      selectedDateRangeCopy.dateStart = this.splitService.getStartDayTimestamp(selectedDateRange.dateStart);
      selectedDateRangeCopy.dateEnd = this.splitService.getEndDayTimestamp(selectedDateRange.dateEnd);

      // The original code
      // var testStart = moment(selectedDateRange.dateStart).startOf('day').valueOf();
      // var testEnd = moment(selectedDateRange.dateEnd).endOf('day').valueOf();

      let selectedTemplate = this.getSelectedTemplate(
        this.customTemplates,
        selectedDateRangeCopy.dateStart,
        selectedDateRangeCopy.dateEnd,
        selectedDateRangeCopy.type,
      );

      this.buttonDisplayName = this.getName(
        selectedDateRangeCopy.dateStart,
        selectedDateRangeCopy.dateEnd,
        _.get(selectedTemplate, 'name')
      );

      let range = {
        name: this.defaultSelection.selectedTemplateName,
        type: _.get(selectedTemplate, 'type'),
        dateStart: selectedDateRangeCopy.dateStart,
        dateEnd: selectedDateRangeCopy.dateEnd
      };

      this.onChange({range: range});
    }
  }

  private getName(dateStart, dateEnd, name) {

    if (name) {
      return this.$filter('translate')(name);
    }

    return this.dateRangeTimeFiltersService.getRangeDisplay(dateStart, dateEnd, this.dateFormat);
  }

  private getSelectedTemplate(templates, dateStart, dateEnd, type?) {
    return _.find(templates, (t) => {
      return (!!type && t.type === type) || _.isEqual(this.moment(t.dateStart).valueOf(), this.moment(dateStart).valueOf()) &&
        _.isEqual(this.moment(t.dateEnd).valueOf(), this.moment(dateEnd).valueOf());
    });
  }

  private getDate(date) {
    return this.configTimeZone && date ?
      new Date(this.moment.tz(date, this.configTimeZone).utcOffset(-(this.configTimeZoneOffset)).toISOString()) :
      undefined;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('dateRangePicker', {
    bindings: {
      selectedRange: '<',
      min: '<?',
      max: "<?",
      customTemplates: '<',
      isDisabled: '<',
      configTimeZone: '<?',
      onChange: '&'
    },
    templateUrl: 'app/modules/commons/components/date-range-picker/date-range-picker.html',
    controller: DateRangePickerComponent
  });
